// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__Fdeqc","active":"Chip_active__PvL5w","trayHighlight":"Chip_trayHighlight__hfLD0","chip_text":"Chip_chip_text__7klpr"};